import React from 'react';
import KioskChrome from './KioskChrome';
import KioskFloatingCart from './KioskFloatingCart';
import KioskRouteGuard from './KioskRouteGuard';
import './kioskFabStack.css';

const KioskLayout: React.FC = () => (
  <>
    <KioskChrome />
    <KioskFloatingCart />
    <KioskRouteGuard />
  </>
);

export default KioskLayout;
